export const INSTAGRAM_URL_ORIGIN = "https://www.instagram.com";
export const INSTAGRAM_USERNAME = "egwwritings";
export const INSTAGRAM_ACCOUNT_URL = INSTAGRAM_URL_ORIGIN + "/" + INSTAGRAM_USERNAME;
